document.addEventListener("DOMContentLoaded", function () {
  const statusText = document.getElementById("permission-status");
  const toggle = document.getElementById("push-toggle");
  const popup = document.getElementById("unsubscribe-popup");

  function updateStatus() {
    const permission = Notification.permission;
    statusText.classList.remove("active", "inactive");

    if (permission === "granted") {
      toggle.checked = true;
      statusText.textContent = "Active";
      statusText.classList.add("active");
    } else if (permission === "denied") {
      toggle.checked = false;
      toggle.disabled = true;
      statusText.textContent = "Blocked";
      statusText.classList.add("inactive");
    } else {
      toggle.checked = false;
      toggle.disabled = false;
      statusText.textContent = "Inactive";
      statusText.classList.add("inactive");
    }
  }

  toggle.addEventListener("change", function () {
    if (toggle.checked) {
      Notification.requestPermission().then((permission) => {
        updateStatus();
        if (permission === "granted" && typeof PushOwl !== "undefined") {
          PushOwl.subscribe();
        }
      });
    } else {
      // Can't revoke permission, show manual instructions
      popup.style.display = "flex";
      activateTab(detectBrowser());
      toggle.checked = true; // prevent false visual feedback
    }
  });

  document.querySelectorAll(".browser-tab").forEach((tab) => {
    tab.addEventListener("click", function () {
      activateTab(this.dataset.tab);
    });
  });

  function activateTab(name) {
    document.querySelectorAll(".browser-instruction").forEach((el) => {
      el.style.display = el.dataset.tab === name ? "flex" : "none";
    });
    document.querySelectorAll(".browser-tab").forEach((tab) => {
      tab.style.fontWeight = tab.dataset.tab === name ? "bold" : "normal";
    });
  }

  function detectBrowser() {
    const ua = navigator.userAgent;
    if (/Chrome/.test(ua) && !/Edg/.test(ua) && !/OPR/.test(ua))
      return "chrome";
    if (/Safari/.test(ua) && !/Chrome/.test(ua)) return "safari";
    if (/Edg/.test(ua)) return "edge";
    return "other";
  }

  updateStatus();
});
